"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutatorAction = exports.createSimpleSubscriber = void 0;
var actionCreator_1 = require("./actionCreator");
var mutator_1 = require("./mutator");
function createSimpleSubscriber(decorator) {
    return function simpleSubscriber(actionType, target) {
        var simpleActionCreator = actionCreator_1.action(actionType, function simpleActionCreator() {
            return {
                args: arguments,
            };
        });
        decorator(simpleActionCreator, function simpleSubscriberCallback(actionMessage) {
            return target.apply(null, actionMessage.args);
        });
        return simpleActionCreator;
    };
}
exports.createSimpleSubscriber = createSimpleSubscriber;
exports.mutatorAction = createSimpleSubscriber(mutator_1.default);
